import { makeObservable, observable, computed } from "mobx"


class Loading {
  
  visible = true

  animDone = null

  constructor() {
      makeObservable(this, {
        visible: observable
      })
  }

  show() {
    return new Promise(resolve => {
      if (!this.visible) {
        this.animDone = resolve
        this.visible = true
      } else
        resolve()
    })
  }

  hide() {
    return new Promise(resolve => {
      if (this.visible) {
        this.animDone = resolve
        this.visible = false
      } else
        resolve()
    })
  }

  
}

export default new Loading()